import { render, staticRenderFns } from "./ApprovalFormsEditor.vue?vue&type=template&id=f2a12e0e&scoped=true&"
import script from "./ApprovalFormsEditor.vue?vue&type=script&lang=js&"
export * from "./ApprovalFormsEditor.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalFormsEditor.vue?vue&type=style&index=0&id=f2a12e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a12e0e",
  null
  
)

export default component.exports